import { number, string } from 'prop-types';

const RouteDataBasicInformationPropTypes = {
  id: number.isRequired,
  fileName: string.isRequired,
  fileUrl: string.isRequired,
  createDate: number.isRequired,
  serviceEndDate: number.isRequired,
  serviceStartDate: number.isRequired,
};

export default RouteDataBasicInformationPropTypes;
